<template>
  <div class="container">
    <h2 class="page-title">Patient Communications</h2>

    <div class="patient-info">
      <h3>Patient Details</h3>
      <p><strong>Name:</strong> {{ patient.name }}</p>
      <p><strong>Phone:</strong> {{ patient.phone }}</p>
      <p><strong>Email:</strong> {{ patient.email }}</p>
      <p><strong>Hospital Number:</strong> {{ patient.hospital_no }}</p>
    </div>

    <div class="tabs">
      <button
        :class="{ active: activeTab === 'email' }"
        @click="activeTab = 'email'"
      >
        📧 Send Email
      </button>
      <button
        :class="{ active: activeTab === 'sms' }"
        @click="activeTab = 'sms'"
      >
        📱 Send SMS
      </button>
    </div>

    <div class="tab-content">
      <div v-if="activeTab === 'email'">
        <h3>Compose Email</h3>
        <div class="form-group">
          <label>To:</label>
          <input type="text" v-model="patient.email" disabled />
        </div>
        <div class="form-group">
          <label>Subject:</label>
          <input
            type="text"
            v-model="email.subject"
            placeholder="Enter subject"
          />
        </div>
        <div class="form-group">
          <label>Message:</label>
          <textarea
            v-model="email.body"
            placeholder="Type your email message"
            rows="6"
          ></textarea>
        </div>
        <button class="btn-send">Send Email</button>
      </div>

      <div v-else-if="activeTab === 'sms'">
        <h3>Send SMS</h3>
        <div class="form-group">
          <label>To:</label>
          <input type="text" v-model="patient.phone" disabled />
        </div>
        <div class="form-group">
          <label>Message:</label>
          <textarea
            v-model="sms.message"
            placeholder="Type SMS message (max 160 chars)"
            maxlength="160"
            rows="4"
          ></textarea>
        </div>
        <button class="btn-send">Send SMS</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PatientCommunications",
  data() {
    return {
      patient: {
        name: "Jane Wanjiku",
        phone: "+254712345678",
        email: "jane.wanjiku@example.com",
        hospital_no: "NH123456",
      },
      activeTab: "email",
      email: {
        subject: "",
        body: "",
      },
      sms: {
        message: "",
      },
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 720px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ccc;
  background: #fdfdfd;
  border-radius: 8px;
}

.page-title {
  font-size: 26px;
  margin-bottom: 20px;
  text-align: center;
}

.patient-info {
  margin-bottom: 20px;
  background: #f2f6fa;
  padding: 12px;
  border-radius: 6px;
}

.patient-info h3 {
  margin-bottom: 8px;
  font-size: 18px;
}

.tabs {
  display: flex;
  margin-bottom: 16px;
}

.tabs button {
  flex: 1;
  padding: 10px;
  border: none;
  background: #e0e0e0;
  cursor: pointer;
  font-weight: bold;
  font-size: 15px;
}

.tabs button.active {
  background: #0077cc;
  color: white;
}

.tab-content {
  margin-top: 10px;
}

.form-group {
  margin-bottom: 12px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.btn-send {
  background: #28a745;
  color: white;
  padding: 10px 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-send:hover {
  background: #218838;
}
</style>
